<template>
    <div>
        <div class="bz-container">
            <div class="bz-title">
              <span>常见问题</span>
            </div>
          <div class="bz-titlebox">
            <div class="bz-worp">
              <div class="bz-box">
                <div class="bz-sskuang">
                  <span><img class="bz-sousuoimg" src="/static/img/assets/sou.png" alt=""></span>
                  <input class="bz-sousuo" type="text" placeholder="请输入标题搜索" v-model="searchVal"/>
                </div>
                <button class="bz-btn">搜索</button>
              </div>
              <div class="bz-right-conent">
                <ul>
                  <li v-for="(d , i) in list" :key="i">
                    <div class="over Text-title" @click="shows(d,i)">
                      <span class="left bz-yuandian"></span>
                      <!-- <span class="left bz-txttitle">{{d.title}}</span> -->
                      <span class="left bz-txttitle" v-html="keyword(d.title,searchVal)"></span>
                      <img  class="right bz-copy" :class="d.isshow ? 'rotates' : 'norotate'" src="/static/img/TriangleCopy.png" alt="">
                    </div>
                    <div ref="title" class="Text-content" :class="d.isshow ? 'dispays' : 'hides'">
                      <p ref="text">{{d.centent}}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
          return {
            arr:[
              {isshow: true, title:'1、如何注册开通云系统？',centent:'答：首先进入【云系统】(http://saas.usoftchina.com) 进行注册；已是华商云服的企业用户，进入【云系统】登陆后，在【账户中心】 选择企业点击【开通服务】即可开通。'},
              {isshow: false, title:'2、实际送货数量大于采购单数量如何操作？',centent:'答：若超出部份正好是贵司所需， 按实际收货数量修改采购验收数量(应付款是按已审核的采购验收单金额记账的'},
              {isshow: false, title:'3、为什么新增采购单据时有的物料可自动带出单价， 有的不能？',centent:'答：因为采购单中的单价取的是物料资料中的最新采购单价， 而最新采购单价是采购验收单审核后自动更新至物料资料中的。'},
              {isshow: false, title:'4、采购单分批次交货时，如何操作？ 采购单界面点“转验收单”按钮时会将采购单中的所有都转过去。',centent:'答：采购验收单中可修改数量， 也可删除明细行。 删除后再次收货时在采购单界面点“转验收单”按钮时生成的采购验收单会显示之前删除的那行数据（即所有未交部份均可再显示）'},
              {isshow: false, title:'5、以销代购业务在系统如何操作？即收到客户订单后再采购的业务模式。',centent:'答：销售订单界面点“转采购”按钮。'},
              {isshow: false, title:'6、人员如何分配权限？',centent:'答：快捷方法是在【账户设置】中添加角色，一个账号可充当多个角色且权限是叠加的；也可新增角色自定义分配权限。'},
              {isshow: false, title:'7、人员离职后如何限制不能再登陆系统？',centent:'答：在【系统管理】中的账户设置中将该账户关闭。'},
              {isshow: false, title:'8、制造单中的类型可否新增？',centent:'答：不可以。下拉选项为组装与拆件两种。组装即领料生产成品入库， 拆件即将成品拆解成原材料与半成品。'},
              {isshow: false, title:'9、制造单如何完工与发料？',centent:'答：制造单类型为组装，审核时系统会自动生成原材料的领料单与成品的完工入库单；类型为拆件，审核时会自动生成成品的拆件领料单与原材料的完工入库单'},
              {isshow: false, title:'10、采购单不需要再交货时要如何操作？',centent:'答：进入采购单列表将该采购单关闭即可。'},
              {isshow: false, title:'11、新使用系统时如何处理之前的PO？',centent:'答：将未交货的采购单PO 中待交货的数量当作新系统中的采购数量按原采购单号补入系统。'},
              {isshow: false, title:'12、已交货的采购单没有录入新系统，有退货如何处理？',centent:'答：新增采购验退单， 在备注中写明原PO号。'},
              {isshow: false, title:'13、单据日期是否可修改？ 如今天录单可否将单据日期改为明天？',centent:'答：可以。只要当月没有结账。'},
              {isshow: false, title:'14、发现上个月有张单据做错了， 可否修改？',centent:'答：若上个月已结账，不允许修改，可本月做其它出入库单据补账， 或请财务人员反结账到上个月，修改后再结账'},
              {isshow: false, title:'15、供应商录入时将期初应付录错了，到月底对账才发现，怎么办？',centent:'答：可用其它应付平账， 或反审单据，修改期初应付后再审核业务单据。'},
            ],
            searchVal:'', //默认输入为空
          }
        },
        methods: {
          //点击展开
          shows(d,i){
            d.isshow = !d.isshow;
            let textH =  this.$refs.text[i].offsetHeight;
            this.$refs.title[i].style.height = textH + 'px';
          },
          //搜索文字高亮
          keyword(val,word){
            val = val + '';
            if (val.indexOf(word) !== -1 && word !== '') {
              return val.replace(word, '<font color="#409EFF">' + word + '</font>')
            } else {
              return val
            }
          },
        },
        //通过计算属性过滤数据
        computed:{
            list: function(){
                let list = [];
                let val = this.searchVal.replace(/\s+/g, "")//去除空格
                for (var i=0;i<this.arr.length;i++){
                    if(this.arr[i].title.search(val) != -1){
                        //判断输入框中的值是否可以匹配到数据，如果匹配成功添加到数组
                      list.push(this.arr[i]);
                    }
                }
                return list;
            }
        }
    }
</script>

<style scoped>
.dispays {
  transition: All 0.4s ease-in-out;
  -webkit-transition: All 0.4s ease-in-out;
  -moz-transition: All 0.4s ease-in-out;
  -o-transition: All 0.4s ease-in-out;
}
.hides {
  height: 0 !important;
  margin-bottom: -13px;
  transition: All 0.4s ease-in-out;
  -webkit-transition: All 0.4s ease-in-out;
  -moz-transition: All 0.4s ease-in-out;
  -o-transition: All 0.4s ease-in-out;
}
.Text-title {
  cursor: pointer;
  opacity: 0.9;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #0D253E;
  letter-spacing: 0;
  line-height: 30px;
}
.Text-content {
  float: left;
  width: 90%;
  font-size: 14px;
  margin-left: 4%;
  margin-top: 2%;
}
.rotates {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
}
.norotate {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
}
.bz-container {
    width: 55%;
    margin: 0 auto;
    font-size: 14px;
    margin-top: 11%;
    margin-bottom: 190px;
}
.bz-titlebox {
    background: #FFFFFF;
    border: 1px solid rgba(30,136,245,0.32);
    box-shadow: 0 20px 60px 10px rgba(13,37,62,0.05);
    border-radius: 4px;
}
.bz-title {
    text-align: left;
    font-size: 14px;
    color: white;
    margin-bottom: 36px;
}
.bz-title span {
    background: #1E88F5;
    border-radius: 2px;
    padding: 6px 24px;
}
.bz-copy {
    margin-right: 7px;
    margin-top: 5px;
    transition: All 0.4s ease-in-out;
    -webkit-transition: All 0.4s ease-in-out;
    -moz-transition: All 0.4s ease-in-out;
    -o-transition: All 0.4s ease-in-out;
}
.bz-txttitle {
  width: 90%;
  padding-left: 22px;
  text-indent: -22px;
}
</style>


// WEBPACK FOOTER //
// src/components/conenter/problem.vue